<template>
  <div>
    <swiper
        :slides-per-view="1"
        :space-between="30"
        loop
        :zoom="true"
        :pagination="true"
        @swiper="onSwiperInitMain"
    >
      <swiper-slide
          v-for="image in images"
          :key="image"
          class="centered-slide"
      >
        <div class="swiper-zoom-container centered-slide">
        <img
            :src="image"
            class="img-fluid w-100 mx-auto"
            style="height: 30rem;"
            blank="true"
        >
        </div>
      </swiper-slide>
    </swiper>

    <swiper

        class="mt-5"
        :slides-per-view="3"
        :space-between="30"
        :loop="false"
        :navigation="true"
        @slideChange="onSlideChange"
        @click="onPreviewClick"
        @swiper="onSwiperInitThumbnail"
    >
      <swiper-slide
          v-for="image in images"
          :key="image"
      >
        <div style="height: 7rem; " class="centered-slide">
          <img
              :src="image"
              class=" mw-100 mh-100"
              blank="true"
          >
        </div>

      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import {Navigation, Pagination, Zoom} from 'swiper'

import {SwiperCore, Swiper, SwiperSlide} from 'swiper-vue2'

import 'swiper/swiper-bundle.css'

SwiperCore.use([Navigation, Pagination, Zoom])

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  props: ['images'],
  data() {
    return {
      swiperMain: null,
      swiperThumbnail: null
    };
  },
  methods: {
    onSwiperInitMain(swiper) {
      this.swiperMain = swiper
    },
    onSwiperInitThumbnail(swiper) {
      this.swiperThumbnail = swiper
    },
    onSlideChange(data) {
      this.swiperMain.slideTo(data.activeIndex+2)
    },
    onPreviewClick(data) {
      this.swiperMain.slideTo(data.clickedIndex+1)
    }
  }
}
</script>


<style scoped>
.centered-slide {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>